import { createFileRoute } from '@tanstack/react-router';
import { PersonalSecurityRoute } from './-route-wrappers';

export const Route = createFileRoute('/_authenticated/settings/personal/security/')({
  component: PersonalSecurityRoute,
});
